import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetCategory } from "./redux/slices/GetCategorySlice";
import { Link, useNavigate } from "react-router-dom";

const WebsiteFooter = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state?.category);

  useEffect(() => {
    dispatch(GetCategory());
  }, []);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handleCategoryClick = (category) => {
    const url =
      category?.name && category?._id
        ? category?.category
          ? `/ShowCategoryData/${category.name}/${category._id}/${category.category}`
          : `/ShowCategoryData/${category.name}/${category._id}`
        : "";
    navigate(url);
  };
  return (
    <footer className="bg-black text-white py-10 text-left ">
      <div className=" mx-auto grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 text-sm px-4">
        <div>
          <h3 className="font-bold mb-4">Find It Fast</h3>
          <ul>
            <li className="mb-2">
              <a
                href="/AllProductData"
                className="hover:underline text-gray-400 no-underline"
              >
                View all product
              </a>
            </li>
            {AllCategory?.slice(0, 5).map((category) => (
              <li key={category._id} className="mb-2">
                <button
                  onClick={() => handleCategoryClick(category)}
                  className="hover:underline text-gray-400 line-clamp-1"
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">Other Policies</h3>
          <ul>
            <li className="mb-2">
              <a
                href="/return-policy/"
                className="hover:underline text-gray-400  no-underline"
              >
                Return Policy
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/delivery-information/"
                className="hover:underline text-gray-400  no-underline"
              >
                Delivery Policy
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/shipping-policy/"
                className="hover:underline text-gray-400  no-underline"
              >
                Shipping Policy
              </a>
            </li>
            <li>
              <a
                href="/pricing-and-payments-policy/"
                className="hover:underline text-gray-400  no-underline"
              >
                Payments Policy
              </a>
              <li className="mb-2 mt-2">
                <a
                  href="/disclaimer-policy/"
                  className="hover:underline text-gray-400  no-underline"
                >
                  Disclaimer Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/prebooking-terms-and-conditions/"
                  className="hover:underline text-gray-400  no-underline"
                >
                  Prebooking Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/cancellation-and-return-policy/"
                  className="hover:underline text-gray-400  no-underline"
                >
                  Cancellation Policy
                </a>
              </li>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">Support</h3>
          <ul>
            <li className="mb-2">
              <a href="/faq/" className="hover:underline text-gray-400  no-underline">
                FAQ
              </a>
            </li>
            <li className="mb-2">
              <a href="/about-us/" className="hover:underline text-gray-400  no-underline">
                About US
              </a>
            </li>
            <li className="mb-2">
              <a href="/contact-us/" className="hover:underline text-gray-400  no-underline">
                Contact US
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/refund-return/"
                className="hover:underline text-gray-400  no-underline"
              >
                Refund & Return
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/terms-of-service/"
                className="hover:underline text-gray-400 no-underline"
              >
                Terms Of Services
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/privacy-policy-2/"
                className="hover:underline text-gray-400  no-underline"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">More</h3>
          <ul>
            <li className="mb-2">
              <a href="/how-to/" className="hover:underline text-gray-400  no-underline">
                How To
              </a>
            </li>
            <Link
              to="/ViewAllCategory"
              className="hover:text-red-500 transition duration-300 ease-in-out  no-underline"
            >
              <li className=" hover:underline text-gray-400  cursor-pointer transition duration-200">
                Shop By Category
              </li>
            </Link>
            <Link
              to="/ViewAllBrand"
              className="hover:text-red-500 transition duration-300 ease-in-out no-underline"
            >
              <li className=" hover:underline text-gray-400  cursor-pointer transition duration-200  ">
                Shop By Brand
              </li>
            </Link>
            <Link
              to="/vendor-register/"
              className="hover:text-red-500 transition duration-300 ease-in-out no-underline"
            >
              <li className=" hover:underline text-gray-400  cursor-pointer transition duration-200 mt-2 ">
                Your Seller Account
              </li>
            </Link>

            <li className="mt-2">
              <a href="/my-account/" className="hover:underline text-gray-400 no-underline">
                Login
              </a>
            </li>

            <li className="mt-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.bharatcod&hl=en"
                className="hover:underline text-gray-400 no-underline"
              >
                Download App
              </a>
            </li>
          </ul>
        </div>

        <div className="">
          <h3 className="font-bold mb-4">ADDRESS</h3>
          <p className="mb-2 text-gray-400">
            403, Shagun Tower, Above Apna Sweets, Scheme Number 54,P.u.4,AB
            Rd,vijay Nagar,Indore,Madhy Pradesh 452010 Pradesh
          </p>

          <p className="mb-2 text-gray-400">
            Telephone:{" "}
            <a href="tel:18002029898" className="hover:underline text-blue-700">
              (+91) 9399456176
            </a>
          </p>
          <p className="mb-2 text-gray-400">
            <a href="tel:18002029898" className="hover:underline ">
              Email: info@BharatCod.com
            </a>
          </p>
        </div>
      </div>

      <div className="mx-auto mt-6 border-t border-gray-700 pt-3 text-xs px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p>&copy; All Rights Reserved BharatCod.com</p>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
